module.exports = __webpack_public_path__ + "static/img/logo.e294a87.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/strawberryImg/logo.png
// module id = ZFcE
// module chunks = 1